var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMokiLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 151.338,
    height: 62.905,
    viewBox: "0 0 151.338 62.905",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8704",
    "data-name": "\\uADF8\\uB8F9 8704",
    transform: "translate(-2331.598 -2401.069)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8684",
    "data-name": "\\uADF8\\uB8F9 8684",
    transform: "translate(2362.358 2455.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8669",
    "data-name": "\\uADF8\\uB8F9 8669",
    transform: "translate(0 0.137)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8668",
    "data-name": "\\uADF8\\uB8F9 8668"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4722",
    "data-name": "\\uD328\\uC2A4 4722",
    d: "M2446.688,2601.211h-3.3l-.539,1.594H2441.2l2.89-8.028h1.9l2.89,8.028h-1.651Zm-.47-1.387-1.181-3.475-1.181,3.475Z",
    transform: "translate(-2441.195 -2594.777)",
    fill: "#010000"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8671",
    "data-name": "\\uADF8\\uB8F9 8671",
    transform: "translate(16.508 0.137)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8670",
    "data-name": "\\uADF8\\uB8F9 8670"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4723",
    "data-name": "\\uD328\\uC2A4 4723",
    d: "M2504.563,2602.805l-1.651-2.89h-1.353v2.89h-1.548v-8.028h2.775a2.7,2.7,0,0,1,2.993,2.626,2.329,2.329,0,0,1-1.41,2.19l1.972,3.211Zm-3-4.232h1.227c.8,0,1.4-.367,1.4-1.169,0-.723-.528-1.181-1.4-1.181h-1.227Z",
    transform: "translate(-2500.011 -2594.777)",
    fill: "#010000"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8673",
    "data-name": "\\uADF8\\uB8F9 8673",
    transform: "translate(31.204 0.137)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8672",
    "data-name": "\\uADF8\\uB8F9 8672"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4724",
    "data-name": "\\uD328\\uC2A4 4724",
    d: "M2557.784,2596.223h-1.927v6.583h-1.56v-6.583h-1.927v-1.446h5.413Z",
    transform: "translate(-2552.371 -2594.777)",
    fill: "#010000"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8675",
    "data-name": "\\uADF8\\uB8F9 8675",
    transform: "translate(56.562 0.137)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8674",
    "data-name": "\\uADF8\\uB8F9 8674"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4725",
    "data-name": "\\uD328\\uC2A4 4725",
    d: "M2647.226,2602.805l-2.959-3.728v3.728h-1.548v-8.028h1.548v3.831l2.764-3.831h1.778l-2.993,3.957,3.291,4.071Z",
    transform: "translate(-2642.719 -2594.777)",
    fill: "#010000"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8677",
    "data-name": "\\uADF8\\uB8F9 8677",
    transform: "translate(71.774 0.137)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8676",
    "data-name": "\\uADF8\\uB8F9 8676"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4726",
    "data-name": "\\uD328\\uC2A4 4726",
    d: "M2698.466,2594.777v8.028h-1.548v-8.028Z",
    transform: "translate(-2696.918 -2594.777)",
    fill: "#010000"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8679",
    "data-name": "\\uADF8\\uB8F9 8679",
    transform: "translate(82.434 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8678",
    "data-name": "\\uADF8\\uB8F9 8678"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4727",
    "data-name": "\\uD328\\uC2A4 4727",
    d: "M2743.066,2598.44a4.083,4.083,0,1,1-4.082-4.152A4.019,4.019,0,0,1,2743.066,2598.44Zm-1.56,0a2.528,2.528,0,1,0-2.522,2.683A2.517,2.517,0,0,0,2741.507,2598.44Z",
    transform: "translate(-2734.901 -2594.288)",
    fill: "#010000"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8681",
    "data-name": "\\uADF8\\uB8F9 8681",
    transform: "translate(99.023 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8680",
    "data-name": "\\uADF8\\uB8F9 8680"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4728",
    "data-name": "\\uD328\\uC2A4 4728",
    d: "M2800.231,2600.125c0,1.251-.895,2.478-2.993,2.478-1.5,0-2.844-.619-3.234-1.95l1.5-.47a1.588,1.588,0,0,0,1.72,1.055c.8,0,1.446-.309,1.446-1,0-.8-.906-.86-2.18-1.17-1.616-.4-2.156-1.215-2.156-2.328,0-1.514,1.158-2.454,2.833-2.454a2.639,2.639,0,0,1,2.74,1.892l-1.513.367a1.231,1.231,0,0,0-1.308-.895c-.665,0-1.216.344-1.216.987,0,.906,1.021,1.032,1.766,1.2C2799.543,2598.279,2800.231,2598.83,2800.231,2600.125Z",
    transform: "translate(-2794.004 -2594.288)",
    fill: "#010000"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8683",
    "data-name": "\\uADF8\\uB8F9 8683",
    transform: "translate(114.189 0.137)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8682",
    "data-name": "\\uADF8\\uB8F9 8682"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4729",
    "data-name": "\\uD328\\uC2A4 4729",
    d: "M2852.548,2602.805l-2.959-3.728v3.728h-1.548v-8.028h1.548v3.831l2.764-3.831h1.777l-2.993,3.957,3.291,4.071Z",
    transform: "translate(-2848.041 -2594.777)",
    fill: "#010000"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8691",
    "data-name": "\\uADF8\\uB8F9 8691",
    transform: "translate(2331.598 2455.299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8687",
    "data-name": "\\uADF8\\uB8F9 8687",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8685",
    "data-name": "\\uADF8\\uB8F9 8685",
    transform: "translate(0.246 0.191)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4730",
    "data-name": "\\uD328\\uC2A4 4730",
    d: "M2333.333,2601.753a2.5,2.5,0,0,0,.906.611,2.741,2.741,0,0,0,.994.2,2.275,2.275,0,0,0,.877-.167,1.575,1.575,0,0,0,.648-.476,1.162,1.162,0,0,0,.245-.742,1.093,1.093,0,0,0-.255-.739,2.313,2.313,0,0,0-.664-.518q-.409-.221-.867-.424-.38-.172-.755-.362a3.814,3.814,0,0,1-.679-.437,1.921,1.921,0,0,1-.487-.585,1.69,1.69,0,0,1-.182-.812,1.784,1.784,0,0,1,.333-1.088,2.127,2.127,0,0,1,.9-.695,3.151,3.151,0,0,1,1.257-.242,4.338,4.338,0,0,1,.953.112,4.537,4.537,0,0,1,.984.351l-.369.781a2.93,2.93,0,0,0-.755-.312,3.1,3.1,0,0,0-.76-.1,2.06,2.06,0,0,0-1.133.3,1.036,1.036,0,0,0-.231,1.531,2.178,2.178,0,0,0,.624.474q.385.2.823.4.391.177.781.375a4.048,4.048,0,0,1,.713.458,2.05,2.05,0,0,1,.518.617,1.746,1.746,0,0,1,.2.851,2.01,2.01,0,0,1-.356,1.171,2.448,2.448,0,0,1-.971.812,3.17,3.17,0,0,1-1.395.3,3.818,3.818,0,0,1-1.213-.2,3.586,3.586,0,0,1-1.134-.63Z",
    transform: "translate(-2332.763 -2595.187)",
    fill: "#010000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4731",
    "data-name": "\\uD328\\uC2A4 4731",
    d: "M2334.934,2603.259a3.92,3.92,0,0,1-1.24-.208,3.691,3.691,0,0,1-1.163-.645l-.057-.046.552-.971.081.083a2.517,2.517,0,0,0,2.682.621,1.507,1.507,0,0,0,.613-.45,1.068,1.068,0,0,0,.226-.688,1.016,1.016,0,0,0-.234-.683,2.244,2.244,0,0,0-.64-.5c-.265-.144-.555-.286-.86-.421-.256-.116-.512-.238-.759-.364a3.948,3.948,0,0,1-.695-.448,2.032,2.032,0,0,1-.508-.611,1.781,1.781,0,0,1-.193-.853,1.881,1.881,0,0,1,.35-1.139,2.229,2.229,0,0,1,.934-.724,3.688,3.688,0,0,1,2.262-.135,4.647,4.647,0,0,1,1,.358l.078.037-.447.944-.082-.048a2.829,2.829,0,0,0-.731-.3,2.329,2.329,0,0,0-1.825.192.949.949,0,0,0-.213,1.4,2.082,2.082,0,0,0,.6.455c.254.134.529.268.817.4.256.116.52.243.784.376a4.166,4.166,0,0,1,.728.468,2.13,2.13,0,0,1,.54.643,1.838,1.838,0,0,1,.206.892,2.1,2.1,0,0,1-.372,1.221,2.548,2.548,0,0,1-1,.841A3.27,3.27,0,0,1,2334.934,2603.259Zm-2.235-.942a3.514,3.514,0,0,0,1.051.57,3.749,3.749,0,0,0,1.185.2,3.1,3.1,0,0,0,1.357-.288,2.387,2.387,0,0,0,.938-.783,1.94,1.94,0,0,0,.341-1.122,1.675,1.675,0,0,0-.184-.809,1.96,1.96,0,0,0-.5-.59,3.991,3.991,0,0,0-.7-.449c-.262-.132-.524-.257-.778-.372-.292-.132-.57-.268-.827-.4a2.257,2.257,0,0,1-.649-.492,1.122,1.122,0,0,1,.25-1.661,2.154,2.154,0,0,1,1.179-.316,3.176,3.176,0,0,1,.781.1,2.96,2.96,0,0,1,.695.275l.293-.618a4.426,4.426,0,0,0-.888-.308,3.486,3.486,0,0,0-2.156.125,2.047,2.047,0,0,0-.862.667,1.711,1.711,0,0,0-.316,1.036,1.6,1.6,0,0,0,.172.77,1.838,1.838,0,0,0,.465.56,3.781,3.781,0,0,0,.664.428c.245.124.5.245.751.359.309.138.6.281.872.427a2.419,2.419,0,0,1,.688.539,1.18,1.18,0,0,1,.276.8,1.256,1.256,0,0,1-.263.8,1.663,1.663,0,0,1-.683.5,2.611,2.611,0,0,1-1.935-.028,2.572,2.572,0,0,1-.856-.551Z",
    transform: "translate(-2332.475 -2594.967)",
    fill: "#010000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8686",
    "data-name": "\\uADF8\\uB8F9 8686"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4732",
    "data-name": "\\uD328\\uC2A4 4732",
    d: "M2334.59,2603.095a4.021,4.021,0,0,1-1.272-.213,3.815,3.815,0,0,1-1.2-.663l-.125-.1.664-1.169.178.185a2.415,2.415,0,0,0,2.566.6,1.4,1.4,0,0,0,.571-.418.968.968,0,0,0,.2-.623.9.9,0,0,0-.209-.614,2.126,2.126,0,0,0-.61-.475c-.263-.143-.55-.283-.853-.418-.258-.116-.511-.238-.764-.366a4.068,4.068,0,0,1-.714-.459,2.112,2.112,0,0,1-.534-.644,1.871,1.871,0,0,1-.206-.9,1.982,1.982,0,0,1,.37-1.2,2.323,2.323,0,0,1,.977-.758,3.774,3.774,0,0,1,2.327-.141,4.787,4.787,0,0,1,1.026.366l.169.083-.54,1.14-.179-.105a2.748,2.748,0,0,0-.705-.292,2.234,2.234,0,0,0-1.743.178.846.846,0,0,0-.191,1.244,2.015,2.015,0,0,0,.571.431q.38.2.812.4c.263.119.525.246.789.378a4.268,4.268,0,0,1,.747.48,2.241,2.241,0,0,1,.566.673,1.952,1.952,0,0,1,.219.942,2.212,2.212,0,0,1-.39,1.28,2.66,2.66,0,0,1-1.044.875A3.377,3.377,0,0,1,2334.59,2603.095Zm-2.1-1.074a3.4,3.4,0,0,0,.948.5,3.343,3.343,0,0,0,2.464-.085,2.279,2.279,0,0,0,.9-.749,1.81,1.81,0,0,0,.322-1.062,1.572,1.572,0,0,0-.171-.759,1.852,1.852,0,0,0-.471-.56,3.87,3.87,0,0,0-.679-.437q-.386-.2-.773-.371-.443-.2-.833-.406a2.35,2.35,0,0,1-.678-.516,1.226,1.226,0,0,1,.271-1.818,2.6,2.6,0,0,1,2.042-.227,3.053,3.053,0,0,1,.622.234l.2-.425a4.217,4.217,0,0,0-.771-.257,3.386,3.386,0,0,0-2.091.119,1.952,1.952,0,0,0-.82.633,1.584,1.584,0,0,0-.3.974,1.5,1.5,0,0,0,.16.721,1.713,1.713,0,0,0,.438.527,3.586,3.586,0,0,0,.645.416c.248.125.5.244.747.357.311.139.606.284.878.43a2.543,2.543,0,0,1,.719.562,1.288,1.288,0,0,1,.3.864,1.354,1.354,0,0,1-.286.86,1.762,1.762,0,0,1-.725.534,2.72,2.72,0,0,1-2.013-.026,2.663,2.663,0,0,1-.792-.483Z",
    transform: "translate(-2331.885 -2594.507)",
    fill: "#010000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4733",
    "data-name": "\\uD328\\uC2A4 4733",
    d: "M2334.3,2602.961a4.1,4.1,0,0,1-1.3-.218,3.879,3.879,0,0,1-1.223-.678l-.183-.148.758-1.334.259.268a2.329,2.329,0,0,0,2.471.576,1.313,1.313,0,0,0,.536-.392.883.883,0,0,0,.185-.57.818.818,0,0,0-.188-.557,2.033,2.033,0,0,0-.585-.455c-.259-.14-.544-.28-.846-.415-.258-.116-.516-.24-.768-.367a4.152,4.152,0,0,1-.729-.469,2.2,2.2,0,0,1-.555-.671,1.955,1.955,0,0,1-.216-.943,2.069,2.069,0,0,1,.387-1.252,2.412,2.412,0,0,1,1.013-.786,3.88,3.88,0,0,1,2.38-.146,4.878,4.878,0,0,1,1.044.373l.247.12-.617,1.3-.262-.153a2.652,2.652,0,0,0-.682-.282,2.131,2.131,0,0,0-1.674.168.759.759,0,0,0-.173,1.112,1.928,1.928,0,0,0,.546.412c.26.137.532.269.806.393.259.117.518.241.792.381a4.322,4.322,0,0,1,.763.49,2.326,2.326,0,0,1,.586.7,2.028,2.028,0,0,1,.23.983,2.3,2.3,0,0,1-.406,1.33,2.746,2.746,0,0,1-1.078.9A3.457,3.457,0,0,1,2334.3,2602.961Zm-2.481-1.086.068.056a3.732,3.732,0,0,0,1.168.648,3.943,3.943,0,0,0,1.245.208,3.3,3.3,0,0,0,1.441-.307,2.571,2.571,0,0,0,1.011-.846,2.129,2.129,0,0,0,.374-1.231,1.864,1.864,0,0,0-.207-.9,2.154,2.154,0,0,0-.544-.647,4.131,4.131,0,0,0-.732-.471c-.273-.138-.529-.261-.785-.377-.278-.126-.553-.259-.817-.4a2.091,2.091,0,0,1-.595-.45.932.932,0,0,1,.21-1.374,2.31,2.31,0,0,1,1.81-.189,2.849,2.849,0,0,1,.728.3l.1.057.463-.976-.092-.046a4.662,4.662,0,0,0-1.008-.359,3.7,3.7,0,0,0-2.273.136,2.24,2.24,0,0,0-.941.729,1.9,1.9,0,0,0-.354,1.149,1.8,1.8,0,0,0,.195.861,2.031,2.031,0,0,0,.513.618,3.964,3.964,0,0,0,.7.449c.249.127.5.249.76.363.306.137.6.279.858.421a2.2,2.2,0,0,1,.634.5.981.981,0,0,1,.23.67,1.048,1.048,0,0,1-.222.677,1.48,1.48,0,0,1-.606.445,2.5,2.5,0,0,1-2.662-.616l-.1-.1Zm2.5.7a3.805,3.805,0,0,1-1.2-.2,3.455,3.455,0,0,1-.972-.511l-.062-.046.346-.609.08.071a2.59,2.59,0,0,0,.766.467,2.637,2.637,0,0,0,1.949.027,1.68,1.68,0,0,0,.69-.509,1.271,1.271,0,0,0,.267-.806,1.2,1.2,0,0,0-.28-.807,2.455,2.455,0,0,0-.694-.542c-.274-.147-.568-.291-.872-.427-.254-.115-.506-.235-.751-.36a3.686,3.686,0,0,1-.661-.426,1.818,1.818,0,0,1-.461-.554,1.591,1.591,0,0,1-.17-.762,1.668,1.668,0,0,1,.313-1.025,2.036,2.036,0,0,1,.855-.662,3.5,3.5,0,0,1,2.144-.124,4.343,4.343,0,0,1,.788.262l.081.036-.277.585-.08-.04a2.975,2.975,0,0,0-.6-.226,2.5,2.5,0,0,0-1.974.216,1.139,1.139,0,0,0-.253,1.686,2.272,2.272,0,0,0,.653.5c.253.133.531.269.829.4.264.121.525.246.776.373a3.973,3.973,0,0,1,.695.446,1.949,1.949,0,0,1,.492.586,1.652,1.652,0,0,1,.182.8,1.89,1.89,0,0,1-.337,1.112,2.367,2.367,0,0,1-.93.777A3.069,3.069,0,0,1,2334.324,2602.58Zm-2.006-.8a3.379,3.379,0,0,0,3.26.36,2.2,2.2,0,0,0,.864-.72,1.728,1.728,0,0,0,.306-1.013,1.5,1.5,0,0,0-.16-.718,1.783,1.783,0,0,0-.449-.533,3.746,3.746,0,0,0-.665-.427c-.248-.126-.507-.25-.769-.37-.3-.135-.582-.273-.838-.408a2.436,2.436,0,0,1-.7-.535,1.312,1.312,0,0,1,.29-1.948,2.674,2.674,0,0,1,2.111-.238,3.1,3.1,0,0,1,.559.2l.125-.264a4.163,4.163,0,0,0-.674-.216,3.318,3.318,0,0,0-2.038.114,1.865,1.865,0,0,0-.784.6,1.5,1.5,0,0,0-.279.923,1.418,1.418,0,0,0,.149.68,1.623,1.623,0,0,0,.417.5,3.531,3.531,0,0,0,.63.406c.243.123.493.243.743.356.308.137.606.283.884.433a2.644,2.644,0,0,1,.743.581,1.375,1.375,0,0,1,.322.921,1.432,1.432,0,0,1-.306.914,1.842,1.842,0,0,1-.759.561,2.8,2.8,0,0,1-2.078-.026,2.738,2.738,0,0,1-.737-.43Z",
    transform: "translate(-2331.598 -2594.286)",
    fill: "#010000"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8690",
    "data-name": "\\uADF8\\uB8F9 8690",
    transform: "translate(13.994 0.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8688",
    "data-name": "\\uADF8\\uB8F9 8688",
    transform: "translate(0.191 0.191)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4734",
    "data-name": "\\uD328\\uC2A4 4734",
    d: "M2382.447,2595.83h1.374l2.561,5.485,2.555-5.485h1.343v7.807h-.91V2597l-2.5,5.36h-1l-2.509-5.372v6.646h-.911Z",
    transform: "translate(-2382.36 -2595.743)",
    fill: "#010000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4735",
    "data-name": "\\uD328\\uC2A4 4735",
    d: "M2390.144,2603.5h-1.085v-6.331l-2.356,5.056h-1.115l-.024-.05-2.343-5.016v6.342h-1.085v-7.981h1.517l.023.05,2.482,5.317,2.5-5.367h1.486Zm-.911-.174h.737v-7.633h-1.2l-2.611,5.6-2.616-5.6h-1.232v7.633h.737v-6.951l2.65,5.676h.894l2.641-5.666Z",
    transform: "translate(-2382.137 -2595.521)",
    fill: "#010000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8689",
    "data-name": "\\uADF8\\uB8F9 8689"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4736",
    "data-name": "\\uD328\\uC2A4 4736",
    d: "M2389.981,2603.338h-1.293v-5.965l-2.186,4.69h-1.248l-2.2-4.7v5.977h-1.293v-8.189h1.687l2.439,5.225,2.434-5.225h1.656Zm-.911-.382h.528v-7.425h-1.03l-2.677,5.747-2.682-5.747h-1.062v7.425h.529v-7.315l2.821,6.04h.762l2.811-6.032Z",
    transform: "translate(-2381.678 -2595.063)",
    fill: "#010000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4737",
    "data-name": "\\uD328\\uC2A4 4737",
    d: "M2389.846,2603.2h-1.467v-5.66l-2.043,4.385h-1.358l-.024-.05-2.03-4.348v5.673h-1.467v-8.363h1.829l.023.05,2.361,5.056,2.378-5.106h1.8Zm-1.293-.173h1.12v-8.016h-1.513l-2.49,5.344-2.495-5.344h-1.545v8.016h1.12v-6.282l2.337,5.007h1.137l2.328-5Zm.911-.209h-.7v-7l-2.669,5.727h-.872l-.024-.05-2.656-5.686v7.011h-.7v-7.6h.529v-.195l.091.195h.585l.023.05,2.6,5.577,2.621-5.627h.557l.087-.188v.188h.529Zm-.529-.173h.355V2595.4h-.355Zm-6.923,0h.355V2595.4h-.355Zm3.318-1.276h.651l2.785-5.975h-.365l-2.732,5.865-2.738-5.865h-.392Z",
    transform: "translate(-2381.456 -2594.84)",
    fill: "#010000"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8694",
    "data-name": "\\uADF8\\uB8F9 8694",
    transform: "translate(2331.716 2415.834)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8693",
    "data-name": "\\uADF8\\uB8F9 8693",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8692",
    "data-name": "\\uADF8\\uB8F9 8692"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4738",
    "data-name": "\\uD328\\uC2A4 4738",
    d: "M2340.878,2485.05h-8.859v-30.76h8.367l.215,3.261a10.935,10.935,0,0,1,8.828-3.876q7.106,0,10.058,6.06a11.154,11.154,0,0,1,4.153-4.491,11.726,11.726,0,0,1,6.152-1.569,10.475,10.475,0,0,1,8.705,3.922q3.107,3.922,3.107,10.9v16.549h-8.859V2468.5a7.566,7.566,0,0,0-1.676-5.353,5.467,5.467,0,0,0-8.136.062,7.9,7.9,0,0,0-1.692,5.506v16.333h-8.859V2468.5a7.562,7.562,0,0,0-1.677-5.353,5.467,5.467,0,0,0-8.136.062,7.9,7.9,0,0,0-1.692,5.506Z",
    transform: "translate(-2332.019 -2453.675)",
    fill: "#010000"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8697",
    "data-name": "\\uADF8\\uB8F9 8697",
    transform: "translate(2472.881 2401.069)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8696",
    "data-name": "\\uADF8\\uB8F9 8696",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8695",
    "data-name": "\\uADF8\\uB8F9 8695"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4739",
    "data-name": "\\uD328\\uC2A4 4739",
    d: "M2834.977,2405.991a4.649,4.649,0,1,1,1.353,3.568A4.822,4.822,0,0,1,2834.977,2405.991Zm.492,41.218v-30.76h8.859v30.76Z",
    transform: "translate(-2834.977 -2401.069)",
    fill: "#010000"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8700",
    "data-name": "\\uADF8\\uB8F9 8700",
    transform: "translate(2434.117 2403.108)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8699",
    "data-name": "\\uADF8\\uB8F9 8699",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8698",
    "data-name": "\\uADF8\\uB8F9 8698"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4740",
    "data-name": "\\uD328\\uC2A4 4740",
    d: "M2716.14,2452.435l-11.34-15.183v15.183h-7.938v-44.1h7.938v25.7l9.954-13.545h9.2l-11.4,14.742,13.356,17.2Z",
    transform: "translate(-2696.862 -2408.334)",
    fill: "#010000"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8703",
    "data-name": "\\uADF8\\uB8F9 8703",
    transform: "translate(2390.801 2415.27)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8702",
    "data-name": "\\uADF8\\uB8F9 8702",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8701",
    "data-name": "\\uADF8\\uB8F9 8701"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4741",
    "data-name": "\\uD328\\uC2A4 4741",
    d: "M2542.533,2467.66a15.853,15.853,0,0,1,2.138-8.229,15.417,15.417,0,0,1,5.844-5.69,18.177,18.177,0,0,1,16.872,0,15.46,15.46,0,0,1,5.829,5.69,16.905,16.905,0,0,1,0,16.457,15.454,15.454,0,0,1-5.829,5.691,18.175,18.175,0,0,1-16.872,0,15.411,15.411,0,0,1-5.844-5.691A15.849,15.849,0,0,1,2542.533,2467.66Zm8.613,0a8.353,8.353,0,0,0,2.215,5.937,7.8,7.8,0,0,0,11.2,0,9.064,9.064,0,0,0,0-11.874,7.8,7.8,0,0,0-11.2,0A8.353,8.353,0,0,0,2551.146,2467.66Z",
    transform: "translate(-2542.533 -2451.665)",
    fill: "#010000"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMokiLogo);
export default __webpack_public_path__ + "static/media/moki_logo.c0f92637e61c701694c619b9d7b5c188.svg";
export { ForwardRef as ReactComponent };